module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/unknown@2x-60dda9d07e2b78bdc32c347f7fbcd0b5.png";